import { initializeApp } from 'firebase/app';
import {
	FacebookAuthProvider,
	getAuth,
	signInWithPopup,
	GoogleAuthProvider
} from 'firebase/auth';
import { getFirebaseConfig } from '../../../config/firebaseConfig';
import {
	loginSSOFacebookFailureAction,
	loginSSOGoogleFailureAction
} from '../../../redux/actions/authAction';

const firebaseConfig = getFirebaseConfig();

const app = initializeApp(firebaseConfig);
const authFirebase = getAuth(app);

const facebookAuthProvider = new FacebookAuthProvider();
facebookAuthProvider.addScope('email');
facebookAuthProvider.setCustomParameters({ display: 'popup' });
export const signInWithFacebook = (
	deviceId: string,
	callback: (user: any) => void
) => {
	return async (dispatch: any) => {
		try {
			const res: any = await signInWithPopup(
				authFirebase,
				facebookAuthProvider
			);

			console.log(res);

			const user = {
				tokenId: res._tokenResponse.oauthAccessToken,
				deviceId: deviceId
			};
			callback(user);
		} catch (err) {
			dispatch(loginSSOFacebookFailureAction(err));
		}
	};
};

const googleProvider = new GoogleAuthProvider();

export const signInWithGoogle = (
	deviceId: string,
	callback: (user: any) => void
) => {
	return async (dispatch: any) => {
		try {
			const res: any = await signInWithPopup(authFirebase, googleProvider);

			const user = {
				tokenId: res._tokenResponse.idToken,
				deviceId: deviceId
			};
			callback(user);
		} catch (err) {
			dispatch(loginSSOGoogleFailureAction(err));
		}
	};
};
